<template>
  <div class="article">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <!-- 分栏 -->
      <c-title title="基本内容"></c-title>
      <!-- 标题 -->
      <Title :articleType="articleType" :title.sync="form.title">
        <p class="good-article blue have" @click="articleTips = true">如何写出好文章?</p>
      </Title>
      <!-- 摘要(运营端视频不显示摘要) -->
      <Summary v-if="form.articleType != 7" :summary.sync="form.summary" />
      <!-- 视频 -->
      <upload-video
        :functionIds="{
          searchArticleById: 'health_cmp_business_getArticleById',
          getVodUploadUrl: 'health_cmp_biz_getUploadUrl',
          deleteUploadedVod: 'health_cmp_biz_deleteUploadedVideo',
        }"
        :form.sync="form"
        v-if="form.articleType == 7"
        ref="uploadVideoRef"
      />
      <!-- 视频封面 -->
      <upload-poster-image :form.sync="form" v-if="form.articleType == 7" ref="uploadPosterImgRef"
                           :functionIds="{ setVideoCover: 'health_cmp_biz_setVideoCover' }"/>
      <!-- 文章封面 -->
      <upload-image @change-title-pic="changeTitlePic" :data="form.titlePicUrl" :required='user_identity == 2 ? false : true' />
      <!-- 正文 -->
      <div class="content-item flex">
        <p class="content-item-label"><span class="red">*</span>{{ articleType == 7 ? "视频简介" : "正文" }}</p>
        <c-editor ref="editorRef" :content="form.content" index="1"/>
      </div>
      <div class="content-item flex" v-if="form.articleType == 7" style="display: flex; align-items: center;">
        <p class="content-item-label">内容同步</p>
        <!-- 内容编辑 && 非同步状态下 可以修改为可同步 -->
        <el-checkbox 
          v-if="form.id && res.contentExtend && res.contentExtend.syncToJdDr"
          v-model="syncValue"
          disabled=true
          style="display: flex; align-items: center;">
          同步到京东
        </el-checkbox>
        <el-checkbox
          v-else
          v-model="syncValue"
          @change="handleSyncChange(syncValue)"
          style="display: flex; align-items: center;">
          同步到京东
        </el-checkbox>
      </div>
      <!-- 分栏 -->
      <c-title has-margin="true" title="分类信息"></c-title>
      <!-- 敏感词 -->
      <sensitive-words v-if="user_identity == 3" :sensitiveWords.sync="form.sensitiveWords"/>
      <!-- 原创文章 -->
      <article-source :articleSource.sync="form.articleSource">
        <p class="original-article blue have" @click="originalTips = true">什么是原创文章？</p>
      </article-source>
      <!-- 分享设置 -->
      <show-share :canShare.sync="form.canShare" :canShareHandle="canShareHandle" v-if="canShareFloor.show"></show-share>
      <!-- 转载出处 -->
      <reprinted-from v-if="form.articleSource == 2" :reprintedFrom.sync="form.reprintedFrom"/>
      <!-- 原文发布时间 -->
      <div class="content-item flex"  v-if="form.articleSource == 2" >
        <p class="content-item-label">原文发布时间</p>
         <el-date-picker
          size="small"
          type="datetime"
          v-model="form.originalPublishTime"
          placeholder="请输入原文发布时间"
        >
        </el-date-picker>
      </div>
      <!-- 内容索引 -->
      <div class="content-item flex">
        <p class="content-item-label"><span class="red">*</span>内容索引</p>
        <el-cascader v-model="contentIndexes" :props="indexProps" :options="indexTreeList" @change="handleChange"></el-cascader>
      </div>
      <article-label
        v-if="user_identity == 3"
        :articleId="this.$route.query.id || form.id"
        :functionIds="{ getArticleLabel: 'health_cmp_biz_listContentUserLabels' }"
        ref="labelRef"
        :labelType="$route.query.tenantid == '287' ? 1 : undefined"
      />
      <!-- 疾病标签 -->
      <disease-label
        :data="form.diseaseLabels"
        @changeDiseaseLabels="changeDiseaseLabels"
        :functionIds="{ getDiseases: 'health_cmp_pageDiseaseInfoByParam' }"
      />
      <!-- 症状标签 -->
      <symptom-label
        v-if="form.articleType == 1 || form.articleType == 3"
        :csdata="form.contentSymptoms"
        @changeSymptomLabels="changeSymptomLabels"
        :functionIds="{ getSymptom: 'health_cmp_pageSymptomByName' }"
      />
      <!-- 分栏 -->
      <c-title has-margin="true" title="原始作者"></c-title>
      <!-- 原始作者 -->
      <original-author :functionIds="{ getOriginalAuthors: 'health_cmp_listByDoctorName' }"
                       ref="OriginalAuthorRef"/>
      <!-- 业务栏目渠道 -->
      <businessColumnChannel
        :requestConfigs="{
          getAllUserSetedBizColChannels: {
            functionId: 'health_cmp_biz_listUserContentBusiness',
            params: {
              tenantId: $commonJs.getTenantId(),
            },
          },
        }"
        ref="businessColumnChannel"
      />
      <!--
        {label:'全部状态',value:-1},
        {label:'草稿',value:1},  preview  draft
        {label:'待审核',value:2},  publish
        {label:'已发布',value:3},
        {label:'驳回',value:4},
        {label:'已下线',value:5},
        {label:'冻结',value:6},
        {label:'下线待审核',value:7},
        {label:'已删除',value:8}
      -->
      <!-- 底部按钮组 -->
      <div class="finish-btns">
        <el-button :disabled="requesting" type="primary" @click="saveOrUpdateArticles(2, 'publish')"><span>发布</span>
        </el-button>
        <el-button :disabled="requesting" @click="saveOrUpdateArticles(1, 'draft')"><span>保存草稿</span></el-button>
        <el-button :disabled="requesting" @click="saveOrUpdateArticles(1, 'preview')"><span>预览</span></el-button>
      </div>
    </div>
    <!-- 预览弹窗 -->
    <preview-modal :mUrl.sync="mUrl" :dialogPreVisible.sync="dialogPreVisible" :qrCode="qrCode"/>
    <!-- 如何写出好文章？弹窗 -->
    <article-tip-dialog :articleTips.sync="articleTips" @handleClose="articleTips = false"/>
    <!-- 什么是原创文章？弹窗 -->
    <original-tips-dialog :originalTips.sync="originalTips" @handleClose="originalTips = false"/>
    <!-- 同步失败 弹窗 -->
    <modal
      :isShow.sync="showSyncDialog"
      title="同步失败"
      :btnText="DialogBtn"
      :isShowBtn="ShowBtn"
      :width="Width"
      :haveThree=true
      @clickHandler="syncClickHandler"
    >
      <div class="content-main">同步失败，请先在京东创作服务平台完成个人类型账号注册及认证</div>
    </modal>
  </div>
</template>
<script>
// 工具
import {mapState} from "vuex";
import {getQRCode, form_bak} from '@/utils/tools';
import {request} from '@/utils/axios';
// 子组件
import breadCrumb from "@/components/breadCrumb";
import modal from '@/components/modal'
import AuditInfo from '@/components/customize/AuditInfo';
import CTitle from '@/components/customize/CTitle';
import Title from '@/components/input/Title';
import Summary from '@/components/textarea/Summary';
import uploadVideo from "@/components/upload/uploadVideo";
import uploadPosterImage from "@/components/upload/uploadPosterImage";
import uploadImage from "@/components/upload/uploadImage";
import CEditor from '@/components/editor/CEditor';
import SensitiveWords from '@/components/input/SensitiveWords';
import ArticleSource from '@/components/radio/ArticleSource';
import ShowShare from '@/components/radio/ShowShare';
import ReprintedFrom from '@/components/combination/ReprintedFrom';
import ArticleLevel from '@/components/radio/ArticleLevel';
import ArticleLabel from '@/components/select/ArticleLabel';
import DiseaseLabel from '@/components/combination/DiseaseLabel';
import SymptomLabel from '@/components/combination/SymptomLabel';
import OriginalAuthor from '@/components/select/OriginalAuthor';
import BusinessColumnChannel from "@/components/tag/BusinessColumnChannel";
import PreviewModal from "@/components/pop/PreviewModal";
import ArticleTipDialog from "@/components/pop/ArticleTipDialog";
import OriginalTipsDialog from "@/components/pop/OriginalTipsDialog";
import { writerContentIndexTree } from "@/api/indexs";
import { queryWriterHisSyncConfirm, queryContentUserMapping,saveSyncState, health_cmp_biz_writerQueryContentFloor } from '@/api/user.js'
import utils from "../../../../utils";

const baseUrl = process.env.VUE_APP_BASEURL;
export default {
  data() {
    return {
      baseUrl,
      imgHost: "//image.healthjd.com/da/",
      // 查询文章接口返回的原始数据
      res: {},
      // 什么是原创文章？弹窗
      originalTips: false,
      // 如何写出好文章？弹窗
      articleTips: false,
      // 预览弹框
      dialogPreVisible: false,
      // 身份信息
      user_identity: 0,
      // 公共表单
      form: {
        canShare: true,
        ...this.$commonJs.deepClone(form_bak),
      },
      // 预览弹框二维码
      qrCode: "",
      // 预览弹框文章链接
      mUrl: "",
      // 封面图
      titlePicUrl: [],
      // 点击保存，发布，通过等最下面的按钮请求状态。防止重复提交
      requesting: false,
      indexProps: { // 内容索引props展示
        value: "indexId",
        label: "name",
        children: "contentIndexes"
      },
      // 索引下拉框数据
      indexTreeList: [],
      contentIndexes: [],
      // 默认同步
      syncValue: true,
      // 默认非 不同步继续发布
      publishDesync: false,
      // 同步弹窗
      showSyncDialog: false,
      // 默认未认证
      authFlag: false,
      Width:'400px',
      canShareFloor: {},
    };
  },
  components: {
    breadCrumb,
    // AuditInfo,
    CTitle,
    Title,
    Summary,
    uploadVideo,
    uploadPosterImage,
    uploadImage,
    CEditor,
    SensitiveWords,
    ArticleSource,
    ReprintedFrom,
    // ArticleLevel,
    ArticleLabel,
    DiseaseLabel,
    SymptomLabel,
    OriginalAuthor,
    BusinessColumnChannel,
    PreviewModal,
    ArticleTipDialog,
    OriginalTipsDialog,
    modal,
    ShowShare,
  },
  watch: {
    "form.articleSource"(newVal, oldVal) {
      if (newVal !== 2) {
        this.form.reprintedFrom = "";
        this.form.originalPublishTime = "";
      }
    },
  },

  created() {
    this.user_identity = sessionStorage.getItem("user_identity");
    if (this.$route.query.articleType) {
      this.form.articleType = this.$route.query.articleType;
    }
    // todo
    health_cmp_biz_writerQueryContentFloor({
      tenantId:this.$commonJs.getTenantId(),
      contentId: this.form.id,
      contentType: this.$route.query.articleType
    }).then((res) => {
      // this.form.canShare = true;
      this.canShareFloor = {...res[0]};
      // this.canShareFloor.show = true;
      console.log(this.canShareFloor.show, 'this.canShareFloor')
      
    })

    
    this.getIndexTreeList();
    this.$nextTick(() => {
      // 如果是编辑文章
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id;
        // this.form.canShare = true;
        this.searchArticleById();
      }
    });
    
  },
  mounted() {
    setTimeout(() => {
      // 添加这段代码
      const $el = document.querySelectorAll('.el-cascader-node[aria-owns]');
      console.log($el);
      Array.from($el).map((item) => item.removeAttribute('aria-owns'));
    }, 300);
  },
  computed: {
    // 计算属性的 getter
    ...mapState(["isShowOriginalAuthor", 'userInfo'])
  },
  methods: {
    canShareHandle(val){
      this.form.canShare = val;
    },
    /**
     * @desc 不同步 弹窗
     * @param val  弹窗选项 one为取消 two为去认证 three为不同步，继续发布
     */
     syncClickHandler(val){
      if(val === 'one'){
        // 取消
        this.showSyncDialog = false;
      }else if(val === 'two'){
        // 同步执行函数
        window.open(`https://dr.jd.com/page/registration.html?returnurl=%2Fpage%2Fapp.html%23%2Fhome`,'_blank')
        this.showSyncDialog = false
      }else if(val === 'three'){
        // 不同步继续发布
        this.publishDesync = true
        this.syncValue = false
        this.saveOrUpdateArticles(2, 'publish')
        this.showSyncDialog = false
      }
    },
    handleSyncChange(val){
      console.log(val)
    },
    /**
     * @desc 子组件需要更新父组件的form表单数据, 统一方法
     */
    updateFormByChild(newForm) {
      this.form = newForm;
    },
    /**
     * @desc 由于某些特殊字段，无法使用vue v-model绑定操作，需要js手工赋值，故在保存，预览，提交，发布，审核文章前初始化一些表单的数据,比如上传图片，视频等信息
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：draft:'草稿'，preview:'预览'，publish:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     */
    initFormBeforeAddOrUpdate(val) {
      this.form.tenantId = this.$commonJs.getTenantId();
      // 根据按钮状态修改articleStatus值
      this.form.articleStatus = val;
      // 富文本编辑器标识 0 未知 1 PC1.0 2 PC2.0 3 APP1.0
      this.form.userAgent = 2;
      // 视频文章
      if (this.form.articleType == 7) {
        // 是视频组件和视频封面组件两个组件组成，故这里不好使用ref来构造获取form的articleVideoInfos值的方法，
        // 里面的值由两个组件共同生成。vid，imageUrl分别在两个组件中共同维护
        if (this.form.articleVideoInfos && this.form.articleVideoInfos.length > 0) {
          this.form.articleVideoInfos = [{
            vid: this.form.articleVideoInfos[0].vid,
            imageUrl: this.form.articleVideoInfos[0].imageUrl,
          }];
        } else {
          this.form.articleVideoInfos = [];
        }
      }
      // 索引
      if (this.contentIndexes.length > 0) {
        this.form.contentIndexes = [{indexId: this.contentIndexes[this.contentIndexes.length - 1]}];
      }
      //封面图校验
      if (this.titlePicUrl && this.titlePicUrl.length) {
        let url = this.titlePicUrl[0].url;
        this.form.titlePicUrl = url.replace(this.imgHost, "");
      }
      //正文校验
      this.form.content = this.$refs.editorRef.editor.getContent();

      // 获取业务栏目频道标签数据
      this.$refs.businessColumnChannel.getBizListData(this.form);
      // 原始作者传NULL，代表删除操作， 空对象{}代表第一次创建的时候数据没有数据，传空对象后台自动设置原始作者为自己。
      this.form.originalAuthor = this.form.id ? null : {};
      this.form.originalAuthor = this.$refs.OriginalAuthorRef.mapAuthorOptions()
      // 原始作者 后台数据返回多余字段，在保存提交的时候如果将这些多余字段回传给后台，接口会报错，故这里删除多余字段，
      // user端和man端的多余字段还不太一样，此处需要后台对接口进行优化 backend TODO
      this.form.originalAuthor && this.deleteUserProtype(this.form.originalAuthor);
      this.form.contentLabels &&
      this.form.contentLabels.forEach(item => {
        this.deleteUserProtype(item);
      });
      console.log(this.user_identity)
      // 处理标签数据
      if (this.user_identity == 3) {
        this.$refs.labelRef.getFormLabelData(this.form);
        console.log(this.$refs.labelRef.getFormLabelData(this.form))
      }
    },
    // 索引下拉框数据获取
    getIndexTreeList() {
      writerContentIndexTree({ contentId: this.form.id }).then((res) => {
        // 处理树的叶子结点
        for(let i = 0; i < res.length; i++) {
          this.recursionObj(res[i], (curNode) => {
            curNode.contentIndexes = undefined;
            return curNode;
          }, (node) => node.contentIndexes.length === 0);
        }
        this.indexTreeList = res;
      })
    },
    recursionObj (node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return ;
      }
      for(let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    handleChange(val) {
      this.contentIndexes = val;
    },
    /**
     * @desc 保存，预览，提交，发布，审核文章的检查函数
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：draft:'草稿'，preview:'预览'，publish:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     * @return true: 表单检查通过， false: ....
     */
    checkBeforeAddOrUpdate(val, opt_type) {
      // man端保存文章 和 user端
      //保存文章状态不变
      if (!this.form.title) {
        this.$message.error("文章标题不能为空");
        return false;
      }
      // 视频文章
      if (this.form.articleType == 7) {
        // 非草稿的视频文章都要检查视频文件是否上传
        if (opt_type != "draft" && opt_type != "preview") {
          if (!(this.form.articleVideoInfos && this.form.articleVideoInfos.length > 0 && this.form.articleVideoInfos[0].vid)) {
            this.$message.error("请上传视频文件");
            return false;
          }
        }
      }
      //封面图校验
      if (!this.titlePicUrl || !this.titlePicUrl.length) {
        //bugfix: 保存草稿和预览不效验封面图( 草稿 null 草稿 ) 除运营外 写手视频外 都不效验封面图
        if (
          // USER端： 如果是身份是运营 或者 身份是写手+视频文章， 在发布文章的时候要检查
          // 如果是身份是运营 或者 身份是写手+视频文章
          (this.user_identity == 3 || this.user_identity == 1) &&
          // 在发布文章的时候
          val >= 2
        ) {
          this.$message.error("请上传封面图");
          return false;
        }
      }

      if (val == 2) {
        if (!this.form.content) {
          this.$message.error("文章内容不能为空");
          return false;
        }
        // 索引选择必选
        if (this.form.contentIndexes.length === 0) {
          this.$message.error("请选择内容索引");
          return false;
        }
        // 文章出处
        if (this.form.articleSource == 0 || !this.form.articleSource) {
          this.$message.error("请选择文章出处");
          return;
        }
        //bugfix: 写手端 发布需要效验转载 预览和保存草稿不需要效验 运营端 都需要效验转载字段
        if (this.form.articleSource == 2 && this.form.reprintedFrom == "") {
          this.$message.error("请填写转载文章出处");
          return false;
        }
      }
      return true;
    },
    // 保存
    handleSave(val, type) {
      console.log("保存？",this.authFlag)
      this.initFormBeforeAddOrUpdate(val, type);
      if (!this.checkBeforeAddOrUpdate(val, type)) {
        // 还原文章状态，因为操作没有成功。
        if (this.res && this.res.articleStatus) {
          this.form.articleStatus = this.res.articleStatus;
        }
        return;
      }
      if (!utils.copyPictureCheck(this.form.content, this)) return;
      this.requesting = true;
      let params;
      params = this.$commonJs.deepClone(this.form);
      params.contentSymptoms = this.formatSymptomData(this.form.contentSymptoms, 1); //  症状
      console.log("🚀 ~ file: index.vue:406 ~ saveOrUpdateArticles ~ params:", params)

      delete params.articleLevel
      // 添加是否同步参数
      params = this.syncValue? {...params,  "contentExtend":{"syncToJdDr": true}} : {...params,  "contentExtend":{"syncToJdDr": false}}
      request('health_cmp_biz_writerSaveOrUpdateArticle', params)
        .then(res => {
          // 由于创作者变更关联业务，导致文章无法操作。
          if (res.code == "0309") {
            this.$message.error(res.msg);
            return;
          }
          this.form.id = res.id;
          // 如果是发布操作，调用查重接口
          // if (val == 2 && params.articleSource == 1) {
          // this.queryArticleRiskControl(res.id);
          // }
          // 保存草稿
          if (type == "draft") {
            this.$message.success("文章保存成功");
            // 回显原始作者信息
            this.searchArticleById();
          } else if (type == "publish") {
            this.$message.success("文章发布成功");
            this.$router.push(`/manage`);
          } else if (type == "preview") {
            // 先回显下文章的ID
            this.getPreviewInfoByIdForPin(res.id, 'preview/');
          }
        })
        .catch(error => {
          console.log(error);
          // 由于创作者变更关联业务，导致文章无法操作。
          if (error && error.code == "0309") {
            this.$message.error(error.msg);
          } else {
            this.$message.error("操作失败！");
          }
        })
        .finally(() => {
          this.requesting = false;
        });
    },
    saveOrUpdateArticles(val, type) {
      // 判断是否同步，并校验身份
      if(this.syncValue && !this.publishDesync){
        console.log(this.syncValue,this.publishDesync)
        // 需要同步，校验身份
        const params = {
          tenantId:this.$commonJs.getTenantId(),
          syncDr:true
        }
        queryContentUserMapping(params)
          .then((res)=>{
            // 已认证正常请求
            console.log("已认证？",res)
            if(!res.id){
              // 未认证则弹窗
              console.log("去认证？")
              this.ShowBtn = [true,true,true],
              this.DialogBtn = ['取消','去认证','不同步，继续发布']
              this.showSyncDialog = true
            } else {
              console.log("已认证",res)
              this.authFlag = true
              this.handleSave(val, type)
            }
          })
          .catch((err)=>{
            // 未认证需要认证
            console.log("去认证？",err)
            this.ShowBtn = [true,true,true],
            this.DialogBtn = ['取消','去认证','不同步，继续发布']
            this.showSyncDialog = true
          })
      } else {
        this.handleSave(val, type)
      }
    },
    getPreviewInfoByIdForPin(id, urlPre) {
      let urlAddress = '//beta-api.m.jd.com'
      let devUrl = 'https://cont-yf.jd.com/content/' // 疾病症状预发地址
      let onlineUrl = 'https://cont.jd.com/content/'
      let newUrl;
      if (this.baseUrl === urlAddress) { // 预发
        newUrl = devUrl;
      } else {
        newUrl = devUrl;
      }
      // newUrl = newUrl  + urlPre + id;
      newUrl = `https://laputa.jd.com/article/pages/index/index?articleId=${id}&tenantId=${this.$commonJs.getTenantId()}`
      this.mUrl = newUrl
      getQRCode(this.mUrl, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },

    async searchArticleById(CB) {
      request('health_cmp_business_getArticleById', {
        articleId: this.form.id,
        tenantId: this.$commonJs.getTenantId()
      })
        .then(res => {
          // 暂存接口返回数据
          this.res = res;
          // 置空原始作者外层信息
          this.emptyInfo(res);
          if (res.originalAuthor) {
            this.deleteUserProtype(res.originalAuthor);
          }
          this.form = Object.assign(this.$commonJs.deepClone(form_bak), res);
          console.log(99999999)
          if(this.form.canShare == undefined){
            this.form.canShare = true;
          }
          // 从表格读取是否同步
          this.syncValue = this.form.contentExtend?.syncToJdDr ?? true;
          // 插入编辑器内容
          // this.$refs.editorRef && this.$refs.editorRef.editor.setContent(this.form.content);
          // 回显症状
          if (res.contentSymptoms) {
            this.form.contentSymptoms = this.formatSymptomData(res.contentSymptoms, 2);
          }
          // 原始作者回显 返显示原作者 bugfix: 和产品确认 运营端原作者字段全部禁止编辑
          if (res.originalAuthor) {
            this.$refs.OriginalAuthorRef.authorOptions = [res.originalAuthor];
            this.$refs.OriginalAuthorRef.selectOriginalAuthorId = res.originalAuthor.originalAuthorId
              // res.originalAuthor.originalAuthorName +
              // " " +
              // res.originalAuthor.originalAuthorTitle +
              // " " +
              // res.originalAuthor.originalAuthorUnit +
              // " " +
              // res.originalAuthor.originalAuthorUnit;
          }
          // 如果是视频文章
          if (this.form.articleType == 7) {
            this.$nextTick(() => {
              this.$refs.uploadVideoRef.displayDataToHtml();
            });
          }
          // 设置业务栏目渠道标签数据，并设置选中状态
          this.$refs.businessColumnChannel.refresh({
            articleId: res.id,
            res,
            contentBusinesses: res.contentBusinesses,
            contentCategorys: [],
            // res.contentChannels数据混合了Categorys和Channels的数据，所以每次contentCategorys重新获取应该都是空数组
            contentChannels: res.contentChannels,
          });
          const treeToArrObj = (obj) => {
            if (!obj.contentIndexes || obj.contentIndexes.length === 0) {
              return { indexId: obj.indexId };
            }
            treeToArrObj(obj.contentIndexes[0]);
          }
          const treeToArr = (obj, arr) => {
            if (obj && obj.indexId) {
              arr.push(obj.indexId);
              treeToArr(obj.contentIndexes[0], arr);
            }
            if (!obj || !obj.contentIndexes || obj.contentIndexes.length === 0) {
              return arr;
            }
          }
          if (res?.contentIndexes?.length > 0) {
            const arr = [];
            treeToArr(res.contentIndexes[0], arr)
            this.form.contentIndexes = [treeToArrObj(res.contentIndexes[0])];
            this.contentIndexes = arr;
          }
          CB && CB();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 在置空原始作者外层信息
    emptyInfo(res) {
      delete res.originalAuthorId;
      delete res.originalAuthorPin;
      delete res.originalAuthorType;
    },
    changeDiseaseLabels(data) {
      // 拿到疾病标签
      this.form.diseaseLabels = data;
    },
    // 格式化传递给后端的 症状库 数据，因为后端不能传symptomName; type 1 添加str， 2 去掉str
    formatSymptomData(data, type) {
      const arr = [];
      data.forEach((item) => {
        console.log("🚀 ~ file: index.vue:230 ~ data.forEach ~ item:", item, type)
        const tmpObj = {}
        tmpObj.symptomId = item.symptomId;
        if (type === 1) {
          tmpObj.symptomNameStr = item.symptomName;
        }else {
          tmpObj.symptomName = item.symptomNameStr
        }
        arr.push(tmpObj);
      });
      console.log("🚀 ~ file: index.vue:374 ~ formatSymptomData ~ arr:", arr)
      return arr;
    },
    changeSymptomLabels(data) {
      console.log("🚀 ~ file: index.vue:544 ~ changeSymptomLabels ~ data:", data)
      this.form.contentSymptoms = data;
    },
    changeTitlePic(data) {
      this.titlePicUrl = data;
    },
    //删除不不要的属性
    deleteUserProtype(obj) {
      // user
      delete obj.created;
      delete obj.articleId;
      delete obj.modified;
      delete obj.yn;
      delete obj.updateTime;
      delete obj.createTime;
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/styles/index.scss";
@import "@/assets/css/common/mixin.scss";
@import "@/styles/article_common.scss";

.content-main{
  width: 100%;
  padding: 30px;
  font-size: 16px;
  text-align: center;
}
.article {
  @include article_common;

  .good-article {
    width: 112px !important;
    margin-left: 270px;
    cursor: pointer;
  }

  .original-article {
    width: 114px !important;
    margin-left: 563px;
    cursor: pointer;
  }
}
</style>
